import { render, staticRenderFns } from "./CellReadonly.vue?vue&type=template&id=c68c0c26&"
import script from "./CellReadonly.vue?vue&type=script&lang=js&"
export * from "./CellReadonly.vue?vue&type=script&lang=js&"
import style0 from "./CellReadonly.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports